import { SiteSizeVsSiteValueGraphChart } from '../../../components/graphs/costApproach/SiteSizeVsSiteValueGraphChart.tsx';
import { pngChartMaker } from '../../../components/graphs/pngChartMaker.tsx';
import { Tkv2SiteValueChartsParams } from '../../referenceView/utils/useTkv2SiteValueChartsParams.ts';
import { IMAGE_FACTOR, PNG_WIDTH } from './constants.ts';

export const pngSiteSizeToSiteValueChartMaker = async (
  params: Tkv2SiteValueChartsParams,
): Promise<string | undefined> => {
  const { siteSizeVsSiteValueGraphRows } = params;
  const width = PNG_WIDTH * IMAGE_FACTOR;
  const height = 350 * IMAGE_FACTOR;

  return pngChartMaker(
    SiteSizeVsSiteValueGraphChart,
    {
      data: siteSizeVsSiteValueGraphRows,
      disableAnimations: true,
      showTitle: false,
      width,
      height,
    },
    width,
    height,
  );
};
